import { Injectable } from '@angular/core';

@Injectable()
export class ValidateService {

  constructor() { }

  validateRegister(user){
    if(user.name == '' || user.username == '' || user.email == '' || user.password == '') {
      return false;
    } else {
      return true;
    }
  }

  validateLogin(email:string, password:string): {success:boolean, msg:string, field:string} {
    //1. blank fields
    if(email == '' && password == '') {
      return {success:false, msg:'Please fill out the fields.', field:'both'};
    }
    // console.log('passed blank check with email:', email);
    //2. email regex
    let validEmail = this.validateEmail(email);
    if (!validEmail){
      return {success:false, msg:'Please enter an email address.', field:'email'}
    }
    // console.log('passed email');
    //3. password regex (6 chars, 2 numbers)
    //TODO: Implement password regex
    let validPassword = this.validatePassword(password);
    if (!validPassword){
      return {success:false, msg:'Please enter at least 6 letters and 2 numbers.', field: 'password'}
    }
    // console.log('passed login');
    //is valid
    return {success:true, msg:'login fields are valid', field:'both'}
  }

  //regex: contains at least 2 numbers and 6 characters in any order
  validatePassword(password){
    let re = /^(?=(.*\d){2})(?=.*[a-zA-Z])[0-9a-zA-Z!@#$%]{8,}/;
    let result = re.test(password)
    // console.log('password '+password+' has result '+result);
    return result;
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/validate.service.ts